import { lazy } from '@/service/lazy'

export default [{
  name: 'ExpiradoParceiro',
  path: 'expirado',
  component: lazy('app/auth/login/index')
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/expiradoParceiro.js